<app-header-page>
    <h1>{{ 'HEADERS.MY_WALLETS' | translate }}</h1>
</app-header-page>

<div class="totalPanel">
    <div *ngIf="flowProjection" class="card mb-4 gbo_shadow" style="padding: 45px 3em">
        <ng-container *ngIf="flowProjection">
            <div class="financeTotalSum">
                {{ flowProjection.total | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
            </div>
        </ng-container>
        <h2 style="padding: 0; margin: 50px 0 0 0">{{ 'FINANCE.TEXT.CONTRACTS_LETTERS' | translate }}</h2>
        <div class="" style="display: flex; justify-content: space-between;">

            <div class="row financeApproveTotalSum">
                <div class="float-start p-4">
                    {{ 'FINANCE.TEXT.INCOMING' | translate }}
                    <div class="in">
                        {{ flowProjection.incoming_approved_total || 0 | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                    </div>
                </div>
                <div class="float-start p-4">
                    {{ 'FINANCE.TEXT.OUTCOMING' | translate }}
                    <div class="out">
                        {{ flowProjection.outcoming_approved_total || 0 | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                    </div>
                </div>
            </div>
            <div class="row financeApproveTotalSum">
                <div class="float-start p-4">
                    {{ 'FINANCE.TEXT.INCOMING_PROMISSED' | translate }}
                    <div class="in">
                        {{ flowProjection.incoming_promised_total || 0 | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                    </div>
                </div>
                <div class="float-start p-4">
                    {{ 'FINANCE.TEXT.OUTCOMING_PROMISSED' | translate }}
                    <div class="out">
                        {{ flowProjection.outcoming_promised_total || 0 | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="wallets master">
    <div *ngIf="masterWallet" class="wallet" data-content="master">
        <app-master-wallet
                (emitRefresh)="onLoad()"
                [financeProfile]="financeProfile"
                [forecastData]="forecasts"
                [isLoadingDataError]="isLoadingDataError"
                [isLoadingData]="isLoadingData"

                [wallet]="masterWallet"
        ></app-master-wallet>
    </div>
</div>
<button (click)="modalService.openTemplateModal(createWalletView)"
        class="btn btn-primary"
        data-action="createWallet"> {{ 'FINANCE.BUTTONS.CREATE' | translate }}
</button>

<div *ngFor="let wallet of wallets; let i = index" [attr.data-contract-wallet-index]="i"
     class="wallet mt-3">
    <app-slave-wallet
            (emitRefresh)="getWallets()"
            [financeProfile]="{wallets}"
            [masterWallet]="masterWallet"
            [forecastData]="forecasts"
            [i]="i"
            [isLoadingDataError]="isLoadingDataError"

            [isLoadingData]="isLoadingData"
            [isPrivate]="true"

            [wallet]="wallet"
    ></app-slave-wallet>
</div>

<ng-template #createWalletView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div class="form-group">
            <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
            <input #walletTitle aria-describedby="emailHelp" class="form-control" id="walletName">
            <small class="form-text text-muted" id="walletHelp">{{ 'MODALS.TEXT.WALLET_NAME' | translate }}</small>

            <select class="form-select" disabled style="margin-top: 10px">
                <option>RUB</option>
            </select>
            <small class="form-text text-muted">{{ 'MODALS.TEXT.WALLET_CURRENCY' | translate }}</small>

            <button (click)="onCreateWallet(walletTitle.value, modal)"
                    class="btn btn-block btn-success"
                    data-action="createWalletButton">
                <span>{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
            </button>
        </div>
    </div>
</ng-template>
